module.exports = __webpack_public_path__ + "img/odecu.3a0f02de.png";